import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Category = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [searchParam] = useState(["name"]);

  const getCategory = () => {
    axios.post(API_URL.CATEGORY_LIST, { is_seller: [0, 1] }).then(
      (res) => {
        if (res.data.status === 1) {
          setCategoryData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-center",
        });
      }
    );
  };

  const deleteCategory = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CATEGORY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = categoryData.filter((r) => r.id != row.id);
              setCategoryData(newData);
            }
            toast.success("Delete Successfully", {
              autoClose: 3000,
              position: "top-center",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-center",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getCategory();
  }, []);

  const search = (items) => {
    return items.filter((item) => {
      return searchParam.some((newItem) => {
        return (
          item[newItem] && item[newItem]
            .toString()
            .toLowerCase()
            .indexOf(searchValue.toLowerCase()) > -1
        );
      });
    })
  }

  const searchCategory = (value) => {
    setSearchValue(value);
  }

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>Category({categoryData.length})</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/category/add"} className="btn btn-primary">
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Add Category
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading ? (
                <Loader></Loader>
              ) : (
                <div>
                  <div className="form-group" style={{ maxWidth: '400px' }}>
                    <input
                      type="text"
                      value={searchValue}
                      onChange={(e) => searchCategory(e.target.value)}
                      className="form-control"
                      placeholder="Search"
                    />
                  </div>
                  <div className="table-responsive">
                    <table className="table table-center table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Image</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {search(categoryData).map((row, key) => {
                          return (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>
                                <h2 className="table-avatar">{row.name}</h2>
                              </td>
                              <td>
                                <img src={row.image} width={100} height={100} alt='slider_iamges' />
                              </td>
                              <td>
                                <Link
                                  to={"/admin/category/edit/" + row.id}
                                  className="btn btn-sm btn-secondary me-2"
                                >
                                  <i className="fa fa-edit me-1"></i> Edit
                                </Link>
                                <button
                                  onClick={() => deleteCategory(row)}
                                  className="btn btn-sm btn-danger me-2"
                                >
                                  <i className="fa fa-trash me-1"></i> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
